<div class="onboarding-success">
  <hlm-dialog (closed)="closeDialog()">
    <h2 class="success">Your new business has been created successfully!</h2>

    <button class="ok-button" (click)="closeDialog()">OK</button>
  </hlm-dialog>
</div>
